import React from 'react'
import moment from 'moment'

const currentMonth = moment().month()
const currentYear = moment().year()

const useMonth = ({
    month = currentMonth,
    onMonthChange = () => {},
    year = currentYear,
    onYearChange = () => {},
}) => {
    const date = moment([year, month, 1])
    const onRightClick = React.useCallback(() => {
        const nextMonth = month + 1
        if (nextMonth > 11) {
            onMonthChange(nextMonth - 12)
            onYearChange(year + 1)
        } else {
            onMonthChange(nextMonth)
        }
    }, [month, year, onMonthChange, onYearChange])
    const onLeftClick = React.useCallback(() => {
        const nextMonth = month - 1
        if (nextMonth < 0) {
            onMonthChange(12 + nextMonth)
            onYearChange(year - 1)
        } else {
            onMonthChange(nextMonth)
        }
    }, [month, year, onMonthChange, onYearChange])

    return {
        date,
        onRightClick,
        onLeftClick
    }
}

export default useMonth
